import { FC, useState } from "react";
import { EuiSpacer, EuiTab, EuiTabs } from "@elastic/eui";
import { AccountingInvoiceSummary } from "./AccountingInvoiceSummary";
import { AccountingCommissionsSummary } from "./AccountingCommissionsSummary";
import { AccountingAgreementsSummary } from "./AccountingAgreementsSummary";

enum AccountingTabTypes {
  Agreements = "Agreements",
  Invoices = "Invoices",
  Commissions = "Commissions",
}

export const AccountingTabs: FC = () => {
  const [selectedTab, setSelectedTab] = useState<AccountingTabTypes>(
    AccountingTabTypes.Agreements,
  );

  return (
    <>
      <EuiTabs>
        <EuiTab
          key={"agreements"}
          onClick={() => setSelectedTab(AccountingTabTypes.Agreements)}
          isSelected={selectedTab === AccountingTabTypes.Agreements}
        >
          {AccountingTabTypes.Agreements}
        </EuiTab>
        <EuiTab
          key={"invoices"}
          onClick={() => setSelectedTab(AccountingTabTypes.Invoices)}
          isSelected={selectedTab === AccountingTabTypes.Invoices}
        >
          {AccountingTabTypes.Invoices}
        </EuiTab>
        <EuiTab
          key={"commissions"}
          onClick={() => setSelectedTab(AccountingTabTypes.Commissions)}
          isSelected={selectedTab === AccountingTabTypes.Commissions}
        >
          {AccountingTabTypes.Commissions}
        </EuiTab>
      </EuiTabs>
      <EuiSpacer />
      {selectedTab === AccountingTabTypes.Agreements && (
        <AccountingAgreementsSummary />
      )}
      {selectedTab === AccountingTabTypes.Invoices && (
        <AccountingInvoiceSummary />
      )}
      {selectedTab === AccountingTabTypes.Commissions && (
        <AccountingCommissionsSummary />
      )}
    </>
  );
};
